import { render, staticRenderFns } from "./PronunciationMenu.vue?vue&type=template&id=9a535d62&scoped=true"
import script from "./PronunciationMenu.vue?vue&type=script&lang=js"
export * from "./PronunciationMenu.vue?vue&type=script&lang=js"
import style0 from "./PronunciationMenu.vue?vue&type=style&index=0&id=9a535d62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a535d62",
  null
  
)

export default component.exports